import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../../diccionarios/empModulo';
import { PuntoEntregaModel } from '../../models/puntoEntregaModel';
import { CaracteristicaModel } from '../../models/caracteristicaModel';

@Injectable({
  providedIn: 'root'
})
export class CargosService {

  diccionarioUrl: any;
  urlNomina: string;
  diccionarioUrl_pe: any;
  constructor(private commom: CommonService,
    private utilServices: UtilsService) {
    this.urlNomina = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.epp.administrador;
    this.diccionarioUrl_pe = empModulo.url.epp.puntoEntrega;
  }

  getAllCargos() {
    return this.commom.peticionGetConHeader(this.urlNomina + this.diccionarioUrl.getCargos);
  }

  postCargos(cargosModel: CaracteristicaModel) {
    return this.commom.peticionPostConHeader(this.urlNomina + this.diccionarioUrl.postCargos, cargosModel);
  }

  deleteCargos(idCargo: string) {
    //punto-entrega/delete/{id}
    return this.commom.peticionDeleteConHeader(this.urlNomina + this.diccionarioUrl.postCargos +"/"+ idCargo);
  }



}